import { createStore } from 'vuex';
import actions from './actions';
import getters from './getters';
import { mutations } from './mutations';
import { notification } from 'ant-design-vue';

const state = {
    user:null,
    userPermissions: [],
    roles: [],
    notifications: []
};

const store = createStore({
  state,
  getters,
  mutations,
  actions,
});

export default store;
